<div class="resize-marker-container" [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
     [style.height]="reportTable.height" [ngClass]="{'draw-custom-element':isCustomDrawEnable || reportTable.isCustomElement()}">

  <div *ngIf="reportTable.isSelected" class="resize LT" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('top')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'top', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportTable.isSelected" class="resize CT" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('top')" [style.left]="getResizeMarkerLeft('center')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'top', 'center')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportTable.isSelected" class="resize RT" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('top')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'top', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>

  <div *ngIf="reportTable.isSelected" class="resize LM" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('middle')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'middle', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportTable.isSelected" class="resize RM" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('middle')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'middle', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>

  <div *ngIf="reportTable.isSelected" class="resize LB" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('bottom')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'bottom', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportTable.isSelected" class="resize CB" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('bottom')" [style.left]="getResizeMarkerLeft('center')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'bottom', 'center')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportTable.isSelected" class="resize RB" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('bottom')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportTable.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'bottom', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
</div>
<div [ngClass]="{'highlight-hover' : designService.highlightElement,'draw-custom-element':isCustomDrawEnable || reportTable.isCustomElement()}" [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
     [style.height]="reportTable.height" [style.position]="'absolute'" (click)="onClick($event)"
     draggable="true" (dragstart)="onDragStart($event)" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
  <table *ngIf="reportTable.tableType === 'surveyTable'" [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
         [style.height]="reportTable.height" [style.fontSize]="reportTable.fontSize">
    <thead>
      <tr>
        <th [style.border]="'none'"></th>
        <th *ngFor="let column of reportTable?.columnList" [style.width]="column.width+'mm'" [style.border]="reportTable?.cellBorder"
            [style.padding]="reportTable?.cellPadding+'mm'" [style.textAlign]="column.textAlignment">
          <p [ngClass]="{'upright-text': column.textOrientation === 'vertical'}">{{column?.label}}</p>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of reportTable?.rowList">
        <th *ngIf="row?.isCategory" colspan="100%" [style.border]="reportTable?.cellBorder"
            [style.padding]="reportTable?.cellPadding+'mm'" [style.textAlign]="row.textAlignment">{{row?.label}}</th>
        <th *ngIf="!row?.isCategory" [style.border]="reportTable?.cellBorder"
            [style.padding]="reportTable?.cellPadding+'mm'" [style.textAlign]="row.textAlignment">{{row?.label}}</th>

        <td [style.display]="row?.isCategory ? 'none' : ''" *ngFor="let column of reportTable?.columnList" [style.border]="reportTable?.cellBorder"
             [style.padding]="reportTable?.cellPadding+'mm'" [style.textAlign]="column.textAlignment">
          <input *ngIf="column.inputType==='checkbox'" [name]="row?.label" type="checkbox" />
          <input *ngIf="column.inputType==='text'" class="content-fit" type="text" />
          <input *ngIf="column.inputType==='radio'" [name]="row?.label" type="radio" />
          <textarea *ngIf="column.inputType==='textarea'" class="content-fit"></textarea>
          <select *ngIf="column.inputType==='select'" class="content-fit"></select>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="reportTable.tableType === 'genericTable'">
    <table [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
           [style.height]="reportTable.height" [style.fontSize]="reportTable.fontSize">
      <thead>
        <tr>
          <th *ngFor="let column of reportTable?.columnList" [style.width]="column.width+'mm'" [style.border]="reportTable?.cellBorder"
              [style.padding]="reportTable?.cellPadding+'mm'" [style.textAlign]="column.textAlignment">
            <p [ngClass]="{'upright-text': column.textOrientation === 'vertical'}">{{column?.label}}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td *ngFor="let column of reportTable?.columnList" [style.border]="reportTable?.cellBorder"
              [style.padding]="reportTable?.cellPadding+'mm'" [style.textAlign]="column.textAlignment"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
